import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { LorenBaseCrudService } from "../../services/loren-base-crud-service/loren-base-crud.service";
import { LorenErrorHandlingService } from "../../services/loren-error-handling-service/loren-error-handling-service.service";

export class BaseEntityResolver<T> {
  constructor(
    protected service: LorenBaseCrudService<T>,
    protected resolveName: string,
    protected router: Router,
    protected errorHandlingService: LorenErrorHandlingService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<T> {
    const id = route.params[this.resolveName];

    if (id) {
      return this.service.get(id).pipe(
        map((dataItem) => {
          this.errorHandlingService.setSuccess();
          return dataItem;
        }),
        catchError((err: HttpErrorResponse) => {
          this.errorHandlingService.setGlobalError(err);
          return of(err as T);
        })
      );
    }
  }
}
